import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Team, TeamMember } from '../../../../core/models/models';
import { TeamService } from '../../../../core/services/team.service';

@Component({
  selector: 'app-team-members-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  templateUrl: './team-members-dialog.component.html',
  styleUrl: './team-members-dialog.component.scss'
})
export class TeamMembersDialogComponent implements OnInit {
  members: TeamMember[] = [];
  candidates: TeamMember[] = [];
  errorMessage = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Team,
    private dialogRef: MatDialogRef<TeamMembersDialogComponent>,
    private teamService: TeamService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    if (!this.data.id) {
      return;
    }

    this.teamService.getTeamMembers(this.data.id, '', 0, 1000).subscribe({
      next: res => {
        this.members = res.content;
        this.cdr.detectChanges();
      },
      error: () => {
        this.errorMessage = 'Erreur chargement des membres';
        this.cdr.detectChanges();
      }
    });

    this.teamService.getTeamCandidates(this.data.id, '', 0, 1000).subscribe({
      next: res => {
        this.candidates = res.content;
        this.cdr.detectChanges();
      },
      error: () => {
        this.errorMessage = 'Erreur chargement des candidats';
        this.cdr.detectChanges();
      }
    });
  }

  addMember(member: TeamMember): void {
    if (!this.data.id) {
      return;
    }
    this.teamService.addMembers(this.data.id, [member.id]).subscribe({
      next: () => {
        this.loadData();
        this.cdr.detectChanges();
      },
      error: () => {
        this.errorMessage = 'Impossible d\'ajouter le membre';
        this.cdr.detectChanges();
      }
    });
  }

  removeMember(member: TeamMember): void {
    if (!this.data.id) {
      return;
    }
    this.teamService.removeMember(this.data.id, member.id).subscribe({
      next: () => {
        this.loadData();
        this.cdr.detectChanges();
      },
      error: () => {
        this.errorMessage = 'Impossible de retirer le membre';
        this.cdr.detectChanges();
      }
    });
  }

  onClose(): void {
    this.dialogRef.close(true);
  }
}
